jQuery(document).ready(function ($) {
  initVideoRDTS($);

  function initVideoRDTS() {
    if ($(".videocontainerrdts").length > 0) {
      $(".videocontainerrdts").each(function (index, element) {
        var videourl = "";
        var videotyp = "";
        var videovorschau = "";

        $(this)
          .find(".videoelement")
          .each(function (index, element) {
            videourl = $(element).data("videourl");
            videotyp = $(element).data("videotyp");
            videovorschau = $(element).data("videovorschau");
          });

        var marketingCookie = readCookie("cmplz_marketing");

        if (marketingCookie === "allow") {
          $(".videocookieerror").hide();

          if (videotyp == "youtube") {
            $(this).append(createYouTubeIFrame(videourl, 560, 315));
          } else if (videotyp == "youtube-shorts") {
            $(this).append(createYouTubeIFrame(videourl, 315, 560));
          } else {
            $(this).append("<p>404 Video not found</p>");
          }
        }
      });
    }
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
});

function createYouTubeIFrame(url, width = 560, height = 315) {
  var videoId = extractVideoId(url);
  var returnframe = "<p>Kein Video gefunden</p>";

  if (videoId && videoId.length == 11) {
    returnframe =
      '<iframe width="' +
      width +
      '" height="' +
      height +
      '" src="https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(videoId) +
      '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen loading="lazy" referrerPolicy="strict-origin-when-cross-origin"></iframe>';
  }

  return returnframe;
}

function extractVideoId(url) {
  var videoId = null;

  // Normalize the URL to ensure it's HTTPS
  if (url.startsWith("http://")) {
    url = url.replace("http://", "https://");
  }

  // If it's already an embed URL (including nocookie), extract the ID
  if (url.includes("/embed/")) {
    var embedMatch = url.match(/\/embed\/([a-zA-Z0-9_-]{11})/);
    if (embedMatch) {
      videoId = embedMatch[1];
    }
  }
  // Handle watch URLs
  else if (url.includes("watch?v=")) {
    var watchMatch = url.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
    if (watchMatch) {
      videoId = watchMatch[1];
    }
  }
  // Handle youtu.be URLs
  else if (url.includes("youtu.be/")) {
    var shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
    if (shortMatch) {
      videoId = shortMatch[1];
    }
  }
  // Handle shorts URLs
  else if (url.includes("/shorts/")) {
    var shortsMatch = url.match(/\/shorts\/([a-zA-Z0-9_-]{11})/);
    if (shortsMatch) {
      videoId = shortsMatch[1];
    }
  }

  return videoId;
}
